"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partnerPagesCreateConfig = void 0;
exports.partnerPagesCreateConfig = {
    canCreatePartnerPages: true,
    showCreateNewPartnerPageButton: true,
};
